import React from 'react';

import { Navbar } from './components'
import { AboutUs, Chef, FindUs, Footer, Gallery, Header, Intro, Laurels, SpecialMenu } from './containers'
import './App.css';

const  App = () => (
    <div>
    	<Navbar />
		<Header />
		<AboutUs />
		<SpecialMenu />
		<Chef />
		<Intro />
		<Laurels />
		<Gallery />
		<FindUs />
		<Footer />
    </div>
)

export default App;
